import * as React from 'react';
var Main = function (props) { return (React.createElement("main", { className: "app-main" }, props.children)); };
export default Main;



//////////////////
// WEBPACK FOOTER
// ./src/layout/Main.tsx
// module id = 51
// module chunks = 0